/* eslint-disable ember/no-empty-glimmer-component-classes */
import Component from '@glimmer/component';

// the empty class definition is necessary to be able to look up this component
// via `component:banners/location-settings/capacity-settings-relocated`
export default class WorkplaceProtectSettingsRenamingInfo extends Component {}
